import { preferencesSlice } from '../slices/preferences';
import { useAppDispatch, useAppSelector } from '../';
import { ALARM_SOUNDS_MAP } from '@utils/sounds';

export const usePreferencesFromStore = () => {
  return useAppSelector((state) => state.preferences);
};

export const usePreferencesActions = () => {
  const dispatch = useAppDispatch();

  const setAudio = (audio: keyof typeof ALARM_SOUNDS_MAP) => {
    // Same isolation the slice's own repair does: a `setItem` that throws (full quota, private
    // Safari) must not cost the operator the tone they just picked. Persisting is the nice-to-have
    // here; dispatching is what actually changes the alarm for this session.
    try {
      localStorage.setItem('selectedSound', audio);
    } catch {
      /* the in-memory choice is enough for this session */
    }
    dispatch(preferencesSlice.actions.setAudio(audio));
  };

  return { setAudio };
};
